import React, { useState, useEffect } from 'react';
import { IonContent, IonPage, IonRow, IonCol, IonBadge } from '@ionic/react';
import AppHeader from '../components/AppHeader';
import { TestResult } from '../models';
import ResultsCard from '../components/ResultsCard';
import TestResultRepository from '../repositories/TestResultRepository';

const MyResults: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState<TestResult[]>([]);

  async function fetchAppointments() {
    setIsLoading(true);
    setResults(await TestResultRepository.getTestResults());
    setIsLoading(false);
  }

  useEffect(() => {
    fetchAppointments();
  }, []);

  return (
    <IonPage>
      <AppHeader />
      <IonContent>
        <div className="ion-padding wrapper wrapper--large">
          <IonRow className="ion-align-items-center ion-justify-content-between">
            <IonCol>
              <h2>Mes Résultats</h2>
            </IonCol>
          </IonRow>
          {!isLoading ? (
            <>
              {results.length ? (
                results.map((result) => (
                  <ResultsCard
                    result={result}
                    key={result.id}
                    onBeforeDelete={() => setIsLoading(true)}
                    onDelete={fetchAppointments}
                  />
                ))
              ) : (
                <div className="ion-text-center ion-padding">
                  <IonBadge color="warning" className="ion-text-wrap">
                    Vous n'avez pas de résultat.
                  </IonBadge>
                </div>
              )}
            </>
          ) : (
            <ResultsCard />
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default MyResults;
